<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { Bot, Info } from 'lucide-svelte';
  import Tooltip from './Tooltip.svelte';

  // Overrides the default extraction disclaimer, e.g. for the document chat (Spec 128 E15).
  export let text: string | undefined = undefined;
  // Text colour; the chat passes a stronger one for contrast (Spec 128 review U3).
  let className = 'text-text-muted';
  export { className as class };
  // Short extra note behind an (i), e.g. "no legal advice" in the chat (PO feedback G2).
  export let info: string | undefined = undefined;
</script>

<!-- Reusable AI liability disclaimer. Slot accepts context-specific notes (e.g. legal references). -->

<div class="border-t border-border px-4 py-4 space-y-3 text-xs {className}">
  <div class="flex items-start gap-2">
    <Bot class="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-warning" />
    <p>{text ?? $_('disclaimer.ai')}</p>
    {#if info}
      <Tooltip text={info}>
        <button
          type="button"
          data-testid="ai-disclaimer-info"
          class="inline-flex items-center justify-center w-6 h-6 -my-1 rounded cursor-pointer text-text-secondary hover:text-text focus:outline-none focus-visible:ring-2 focus-visible:ring-accent"
          aria-label={info}
        >
          <Info class="w-3.5 h-3.5" strokeWidth={1.5} />
        </button>
      </Tooltip>
    {/if}
  </div>

  <slot />
</div>
